class localhostSettings { }

const win: any = window;

if (window.location.href.includes("localhost")) {
    !!!win["lang"] && (win["lang"] = "en");
    document.documentElement.lang = win["lang"];
    win["isLoggedIn"] = 'false';

    !!!win['CEM_KEY'] && (win['CEM_KEY'] = import.meta.env.VITE_BM_CI);
    !!!win['clientToken'] && (win['clientToken'] = '3f38a23b-04ca-452c-abbd-ced00077f78b');
    !!!win['base_portal_url'] && (win['base_portal_url'] = 'http://ssta004:8080');
    !!!win["base_api_url"] && (win["base_api_url"] = "https://apisit.mobily.com.sa/api");
    !!!win["errorPageURL"] && (win["errorPageURL"] = "/wps/portal/web/personal/store/error?errorSource=EasyLogin");
}

export default localhostSettings;